/**
 * Loyalty Module
 *
 * Handles loyalty program functionality including:
 * - Points calculation preview
 * - Points adjustment form
 */

import { $, ready } from '../utils/dom.js';

// =============================================================================
// Loyalty Program Form
// =============================================================================

/**
 * Initialize loyalty program form with live calculation preview
 */
function initLoyaltyProgramForm() {
    const pointsPerDollar = $('#points_per_dollar');
    const pointValue = $('#point_value');
    const examplePoints = $('#example-points');
    const exampleValue = $('#example-value');

    if (!pointsPerDollar || !pointValue) return;

    function updateExample() {
        const ppd = parseFloat(pointsPerDollar.value) || 1;
        const pv = parseFloat(pointValue.value) || 0.01;
        const amount = 50; // Example $50 purchase

        const points = Math.round(amount * ppd);
        const value = (points * pv).toFixed(2);

        if (examplePoints) examplePoints.textContent = points;
        if (exampleValue) exampleValue.textContent = '$' + value;
    }

    pointsPerDollar.addEventListener('input', updateExample);
    pointValue.addEventListener('input', updateExample);

    // Initial update
    updateExample();
}

// =============================================================================
// Points Adjustment Form
// =============================================================================

/**
 * Initialize points adjustment form
 */
function initPointsAdjustmentForm() {
    const form = $('#points-adjustment-form');
    if (!form) return;

    const adjustmentType = $('select[name="adjustment_type"]');
    const pointsInput = $('#points');
    const currentPoints = $('#current-points-value');
    const newPointsPreview = $('#new-points-preview');

    if (!adjustmentType || !pointsInput) return;

    function updatePreview() {
        const type = adjustmentType.value;
        const points = parseInt(pointsInput.value) || 0;
        const current = parseInt(currentPoints?.textContent) || 0;

        let newTotal = current;
        if (type === 'add') {
            newTotal = current + points;
        } else if (type === 'subtract') {
            newTotal = Math.max(0, current - points);
        } else if (type === 'set') {
            newTotal = points;
        }

        if (newPointsPreview) {
            newPointsPreview.textContent = newTotal.toLocaleString();
        }
    }

    adjustmentType.addEventListener('change', updatePreview);
    pointsInput.addEventListener('input', updatePreview);

    // Initial update
    updatePreview();
}

// =============================================================================
// Auto-Initialization
// =============================================================================

function initLoyalty() {
    initLoyaltyProgramForm();
    initPointsAdjustmentForm();
}

ready(initLoyalty);

export default {
    initLoyaltyProgramForm,
    initPointsAdjustmentForm
};
